export default {
  tradeIn: {
    id: 'menu_trade-in',
    defaultMessage: 'Trade-in',
  },
}
